<template>
    <div :class="styleMain">
      <el-input :value="display" @input="change" @change="update" @focus="$emit('focus', true)"/>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionMinute',
  props: {
    action: Object
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    display () { return this.value || this.action.minute },

    styleMain () {
      return [
        'sportFootballMatchActionMinute',
        this.action.homeAway,
        [21, 22].indexOf(this.action.typeId) > -1 ? 'timeout' : null
      ]
    }
  },
  methods: {
    change (value) { this.value = value },
    update (value) {
      this.value = null
      this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, minute: value })
    }
  }
}
</script>

<style>
.sportFootballMatchActionMinute {
  grid-area: minute;
}
.sportFootballMatchActionMinute input{
  font-weight:600;
  font-size:16px;
  height:35px;
  text-align:center;
  padding:0
}
.sportFootballMatchActionMinute.home input{
  background-color: var(--color-team-home);
  color:white
}
.sportFootballMatchActionMinute.away input{
  background-color: var(--color-team-away);
  color:white
}
.sportFootballMatchActionMinute.timeout input{
  background-color: var(--color-background-offset-dark);
  color:white
}
.sportFootballMatchActionMinute.home .el-input.is-active .el-input__inner,
.sportFootballMatchActionMinute.home .el-input__inner:focus{
  border-color:var(--color-team-home)
}
.sportFootballMatchActionMinute.away .el-input.is-active .el-input__inner,
.sportFootballMatchActionMinute.away .el-input__inner:focus{
  border-color:var(--color-team-away)
}
</style>
